import React from 'react';
import './emailalert.scss';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close'; // Import CloseIcon

const EmailAlert = (props) => {
  const {
    variant,
    message,
    children,
    title,
    onClose,
    ...restOfProps
  } = props;

  return (
    <div className={`emailAlert ${variant}`} {...restOfProps}>
      <div className='alertHeader'>
        <InfoIcon />
        {title && (
          <p>
            {title}
          </p>
        )}
        {onClose && (
          <button className="closeButton" onClick={onClose} aria-label="Close alert">
            <CloseIcon />
          </button>
        )}
      </div>
      {children}
      {Array.isArray(message) && (
        <p>
          {message.map((item, index) => (
            <span key={index}>
              {item}
              {index < message.length - 1 && ', '}
            </span>
          ))}
        </p>
      )}
    </div>
  );
};

export default EmailAlert;